import React from 'react';
import * as ReactGA from "react-ga";
import LandingPage from "../../LandingPage";
import DealerSignupForm from "./DealerSignupForm";


export default function DealerSignUp(props) {

    const [gaEventSent, setGaEventSent] = React.useState(false);

    if (!gaEventSent) {
        ReactGA.event({
            category: 'User',
            action: 'dealer_signup_page',
            value: window.location.pathname
        });
        setGaEventSent(true);
    }

    return (
        <LandingPage {...props} customContent={<DealerSignupForm isMobile={props.isMobile}/>}/>
    );
}
